<template>
  <div class="modal fade" id="modalSurveyQuestions"
       tabindex="-1" aria-labelledby="modalSurveyQuestions" aria-hidden="true">
    <div class="modal-dialog modal-xxl">
      <div class="modal-content">
        <div class="modal-header bg-light">
          <div class="d-flex align-items-center">
            <div class="symbol symbol-40px me-3">
              <div class="symbol-label bg-primary">
                <i class="bi bi-question-circle fs-2 text-white"></i>
              </div>
            </div>
            <div>
              <h5 class="modal-title mb-0">Gerenciar Perguntas</h5>
              <span class="text-muted fs-7">Configure as perguntas da pesquisa</span>
            </div>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body p-0">
          <!-- Seção de Adicionar Nova Pergunta -->
          <div class="card border-0 shadow-none">
            <div class="card-header bg-primary bg-opacity-10 border-bottom-0">
              <h6 class="card-title mb-0 fw-bold text-white">
                <i class="bi bi-plus-circle-fill text-white me-2"></i>
                Adicionar Nova Pergunta
              </h6>
            </div>
            <div class="card-body">
              <div class="row g-4">
                <!-- Texto da Pergunta -->
                <div class="col-12">
                  <label class="form-label fw-semibold required">
                    Texto da Pergunta
                  </label>
                  <input
                    v-model="newQuestion.sq_question"
                    class="form-control form-control-solid"
                    placeholder="Ex: Como você avalia o atendimento?"
                    required
                  />
                </div>

                <!-- Tipo de Pergunta e Opções de Resposta -->
                <div class="col-md-6">
                  <label class="form-label fw-semibold required">
                    Tipo de Pergunta
                  </label>
                  <select v-model="newQuestion.sq_question_as_text" class="form-select form-select-solid" required>
                    <option :value="true">Texto Livre</option>
                    <option :value="false">Múltipla Escolha (Pré-definidas)</option>
                  </select>
                </div>

                <div class="col-md-6" v-if="!newQuestion.sq_question_as_text">
                  <label class="form-label fw-semibold required">
                    Opções de Resposta
                  </label>
                  <MultiSelect
                    v-model="newQuestion.options"
                    :options="predefinedOptions"
                    appendTo="body" showClear
                    optionLabel="so_text"
                    class="w-full form-control form-control-solid"
                    placeholder="Selecione as opções pré-definidas"
                    :filter="true"
                    :multiple="true"
                    style="display: flex; padding: 0.25rem .75rem"
                  />
                </div>

                <!-- Botão Salvar -->
                <div class="col-12 d-flex justify-content-end">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="submitQuestions"
                    :disabled="(!newQuestion.sq_question_as_text && (!newQuestion.options || newQuestion.options.length === 0)) || !newQuestion.sq_question || newQuestion.sq_question.length === 0"
                  >
                    <i class="bi bi-check-circle me-1"></i>
                    Salvar Pergunta
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Seção de Perguntas Existentes -->
          <div class="separator separator-dashed"></div>

          <div class="px-6 py-4">
            <div class="d-flex align-items-center justify-content-between mb-4">
              <div class="d-flex align-items-center">
                <div class="symbol symbol-40px me-3">
                  <div class="symbol-label bg-success">
                    <i class="bi bi-list-check fs-2 text-white"></i>
                  </div>
                </div>
                <div>
                  <h6 class="mb-0 fw-bold">Perguntas Cadastradas</h6>
                  <span class="text-muted fs-7">{{ questions.length }} pergunta(s)</span>
                </div>
              </div>
            </div>

            <!-- Lista de Perguntas -->
            <div v-if="questions.length > 0" class="row g-4">
              <div v-for="(question, index) in questions" :key="question.id_sq || index"
                   class="col-12">
                <div class="card card-bordered">
                  <div class="card-body p-4">
                    <div class="d-flex align-items-start">
                      <!-- Conteúdo da Pergunta -->
                      <div class="flex-grow-1">
                        <h6 class="mb-2 text-gray-800">{{ question.sq_question }}</h6>

                        <div class="d-flex flex-wrap gap-2 mb-2">
                          <!-- Tipo -->
                          <span class="badge" :class="question.sq_question_as_text ? 'badge-light-primary' : 'badge-light-success'">
                            <i :class="question.sq_question_as_text ? 'bi-chat-text' : 'bi-check-square'" class="me-1"></i>
                            {{ question.sq_question_as_text ? 'Texto Livre' : 'Múltipla Escolha' }}
                          </span>
                        </div>

                        <!-- Opções -->
                        <div v-if="!question.sq_question_as_text && question.options && Array.isArray(question.options) && question.options.length > 0"
                             class="text-muted fs-7">
                          <i class="bi bi-list-ul me-1"></i>
                          {{ question.options.map(o => o.so_text).join(' • ') }}
                        </div>
                      </div>

                      <!-- Ações -->
                      <div class="ms-3">
                        <button
                          type="button"
                          class="btn btn-sm btn-icon btn-light-danger"
                          @click="removeQuestion(question.id_sq)"
                          title="Remover pergunta"
                        >
                          <i class="bi bi-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Estado Vazio -->
            <div v-else class="text-center py-8">
              <div class="symbol symbol-50px mb-4">
                <div class="symbol-label bg-light">
                  <i class="bi bi-question-circle text-muted fs-2x"></i>
                </div>
              </div>
              <h6 class="text-muted mb-2">Nenhuma pergunta cadastrada</h6>
              <p class="text-muted fs-7">Adicione perguntas acima para começar a configurar sua pesquisa</p>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-light" @click="closeModal">
            <i class="bi bi-x-circle me-1"></i>
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "@/helpers/modal";
import MultiSelect from 'primevue/multiselect';
import DropdownUbbi from "@/components/DropdownUbbi.vue";
import http from "@/helpers/http";
import Alert from "@/helpers/alert";

export default {
  name: "SurveyQuestionModal",
  props: ['survey'],
  components: {
    DropdownUbbi,
    MultiSelect,
  },
  data() {
    return {
      predefinedOptions: [
        {so_value: 5, so_text: 'Excelente'},
        {so_value: 4, so_text: 'Bom'},
        {so_value: 3, so_text: 'Indiferente'},
        {so_value: 2, so_text: 'Ruim'},
        {so_value: 1, so_text: 'Péssimo'},
      ],
      newQuestion: {
        sq_question: '',
        sq_question_as_text: false,
        options: []
      },
      questions: [],
    };
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  mounted() {
    this.uniqueKey = this.date().unix().toString();
  },
  watch: {
    survey: {
      immediate: true,
      handler(newValue) {
        this.questions = newValue?.questions || [];
      }
    }
  },
  methods: {
    date: moment,
    async removeQuestion(questionId) {
      try {
        const response = await http.delete(`/places/${this.place.id_place}/surveys/${this.survey.id_survey}/questions/${questionId}`);
        this.questions = response.data.questions || [];
        Alert.toastSuccess('Pergunta removida com sucesso.')
      } catch (error) {
        Alert.toastError(error.response.data)
      }
    },
    async submitQuestions() {
      try {
        const response = await http.post(`/places/${this.place.id_place}/surveys/${this.survey.id_survey}/questions`, this.newQuestion);
        this.questions = response.data.questions || [];
        Alert.toastSuccess('Pergunta adicionada com sucesso.');

        this.newQuestion = {
          sq_question: '',
          sq_question_as_text: false,
          options: []
        };
      } catch (error) {
        Alert.toastError('Erro ao salvar pergunta.')
      }
    },
    closeModal() {
      Modal.toggle('#modalSurveyQuestions');
      this.$emit('onClose');
    }
  },
}
</script>

<style scoped>
.modal-xxl {
  max-width: 1200px;
}

.separator {
  height: 1px;
  background-color: var(--bs-border-color);
  margin: 1rem 0;
}

.separator-dashed {
  background-image: linear-gradient(to right, var(--bs-border-color) 50%, transparent 50%);
  background-size: 8px 1px;
}

.card-bordered {
  border: 1px solid var(--bs-border-color);
  border-radius: 0.75rem;
  box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
}

.text-gray-800 {
  color: #3f4254 !important;
}

.fs-7 {
  font-size: 0.875rem;
}

.fs-2x {
  font-size: 2rem;
}

.px-6 {
  padding-left: 1.5rem !important;
  padding-right: 1.5rem !important;
}

.py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-8 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}

/* Estilização básica do MultiSelect para manter altura consistente */
.p-multiselect {
  min-height: 42px !important;
}

/* Responsividade */
@media (max-width: 768px) {
  .modal-xxl {
    margin: 0.5rem;
    max-width: calc(100vw - 1rem);
  }

  .card-body {
    padding: 1rem;
  }

  .d-flex.align-items-start {
    flex-direction: column;
    align-items: stretch !important;
  }

  .ms-3 {
    margin-left: 0 !important;
    margin-top: 1rem;
  }
}

@media (max-width: 576px) {
  .col-md-6 {
    margin-bottom: 1rem;
  }

  .d-flex.justify-content-end {
    justify-content: center !important;
  }
}
</style>